/**
 * @typedef {import("./Props").default} Props
 */

import { translate } from '../../../../Internationalization';
import BaseButton from '../../../../../shared/BaseButton/BaseButton';
import BaseForm from '../../../../../shared/Forms/BaseForm';
import FilterGroup from '../Types/FilterGroup';
import FormField from '../../../../../shared/Forms/Fields/FormField';
import InputSelect from '../../../../../shared/Forms/Inputs/InputSelect';
import React from 'react';
import SelectOptionList from '../../../../../shared/Forms/Inputs/SelectOptionList';

const statusOptions = {
	'': 'All',
	off: 'OFF',
	on: 'ON',
	removed: 'REMOVED',
};

/** @extends {React.Component<Props>} */
export default class AiMonitoringFilter extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		this.state = {
			active: !!props.query['filter[ai_monitoring.status]'],
			defaultStatusFilter:
				props.query['filter[ai_monitoring.status]'] ?? '',
		};

		this._handleSubmit = this._handleSubmit.bind(this);
		this._handleReset = this._handleReset.bind(this);
	}

	/**
	 * @param {{ai_monitoring_status: string}} values
	 * @returns {void}
	 */
	_handleSubmit(values) {
		if (!values.ai_monitoring_status) {
			this._handleReset();
			return;
		}

		this.props.onSubmit({
			'filter[ai_monitoring.status]': values.ai_monitoring_status,
			relation: 'and',
		});

		this.setState({
			active: true,
			defaultStatusFilter: values.ai_monitoring_status,
		});
	}

	/** @returns {void} */
	_handleReset() {
		const query = this.props.query;

		if (query['filter[ai_monitoring.status]']) {
			delete query['filter[ai_monitoring.status]'];

			this.props.onSubmit({
				...query,
			});
		}

		this.setState({ active: false, defaultStatusFilter: '' });
	}

	/** @returns {JSX.Element} */
	render() {
		return (
			<FilterGroup
				active={this.state.active}
				locked={this.props.gated}
				title="AI Monitoring"
			>
				<BaseForm noRequiredText={true} onSubmit={this._handleSubmit}>
					<div className="flex flex-col gap-4">
						<FormField
							inputName="ai_monitoring_status"
							label={translate('Select status')}
							required={false}
						>
							<InputSelect
								defaultValue={this.state.defaultStatusFilter}
								name="ai_monitoring_status"
								placeholder="Select status"
								type="text"
							>
								<SelectOptionList values={statusOptions} />
							</InputSelect>
						</FormField>

						<div className="flex gap-2">
							<BaseButton
								className="w-fit"
								iconSize="small"
								size="xsmall"
								type="submit"
							>
								{translate('filters.submit')}
							</BaseButton>
							<BaseButton
								className="w-fit"
								iconSize="small"
								onClick={this._handleReset}
								outline={true}
								size="xsmall"
								type="reset"
							>
								{translate('filters.reset')}
							</BaseButton>
						</div>
					</div>
				</BaseForm>
			</FilterGroup>
		);
	}
}
